<template>
  <div class="detail-tool">
    <div class="item" @click="onLike">
      <img
        class="icon"
        :src="
          `${
            detail.is_like
              ? require('@/assets/images/aside_dianzanle.png')
              : require('@/assets/images/aside_dianzan.png')
          }`
        "
      />
      <span class="txt">{{ formatCount(detail.like_count) }}</span>
    </div>
    <div class="divider"></div>
    <div class="item" @click="onFavorite">
      <img
        class="icon"
        :src="
          `${
            detail.is_favorite
              ? require('@/assets/images/aside_shoucangle.png')
              : require('@/assets/images/aside_shoucang.png')
          }`
        "
      />
      <span class="txt">{{ formatCount(detail.favorite_count) }}</span>
    </div>
    <div class="divider"></div>
    <div class="item">
      <img class="icon" :src="`${require('@/assets/images/aside_look.png')}`" />
      <span class="txt">{{ formatCount(detail.view_count) }}</span>
    </div>
    <div class="divider"></div>
    <div class="item" @click="onShare">
      <img class="icon" :src="`${require('@/assets/images/aside_fenxiang.png')}`" />
      <span class="txt">分享</span>
    </div>
  </div>
</template>
<script>
import Clipboard from "clipboard";
import { apiContentLike } from "@/api/contentApi";
import { apiUserAddFavorite } from "@/api/userApi";

export default {
  name: "DetailTool",
  props: {
    detail: {
      type: Object,
      required: true
    }
  },
  methods: {
    // 点赞
    onLike() {
      // if (!this.isLogin()) {
      //   return false;
      // }
      let params = {
        is_like: this.detail.is_like ? 0 : 1,
        origin_id: this.detail.id,
        type: 1
      };
      apiContentLike(params).then(res => {
        this.detail.is_like = params.is_like;
        params.is_like ? this.detail.like_count++ : this.detail.like_count--;
        if (this.detail.like_count < 0) this.detail.like_count = 0;
        this.$emit("refresh", this.detail);
      });
    },
    // 赞赏用户
    onReward() {
      this.$message({
        type: "info",
        message: "功能暂未开放"
      });
    },
    // 收藏文章
    onFavorite() {
      if (!this.isLoginShow()) return false;
      let params = {
        origin_id: this.detail.id,
        type: 1
      };
      apiUserAddFavorite(params).then(res => {
        if (res.code == 0) {
          this.detail.is_favorite = this.detail.is_favorite ? 0 : 1;
          this.detail.is_favorite ? this.detail.favorite_count++ : this.detail.favorite_count--;
          this.$emit("refresh", this.detail);
        }
      });
    },
    onShare() {
      let shareText = `${this.detail.user.username}分享了文章:${this.detail.title}\r\n`;
      shareText += window.location.href + "\r\n";
      shareText += "来自GameKee";

      let $div = document.createElement("div");
      $div.setAttribute("data-clipboard-text", shareText);
      $div.classList.add("page-share-copy-btn");
      document.body.appendChild($div);
      let clipboard = new Clipboard(".page-share-copy-btn");
      clipboard.on("success", e => {
        this.$message("复制成功！");
        document.body.removeChild($div);
        clipboard.destroy();
      });
      clipboard.on("error", e => {
        // 不支持复制
        this.$message("浏览器不支持自动复制,请更换其他浏览器");
        document.body.removeChild($div);
        clipboard.destroy();
      });
      $div.click();
    },
    onComment() {
      window.scrollTo({
        top: document.querySelector(".wiki-detail-comment").offsetTop,
        behavior: "smooth"
      });
    },
    formatCount(count) {
      if (count > 100000000) {
        const num = count / 100000000;
        if (num == (count / 100000000).toFixed(1)) {
          return num + "亿";
        } else {
          return (count / 100000000).toFixed(1) + "亿+";
        }
      } else if (count >= 10000) {
        const num = count / 10000;
        if (num == (count / 10000).toFixed(1)) {
          return num + "W";
        } else {
          return (count / 10000).toFixed(1) + "W+";
        }
      } else if (count >= 1000) {
        const num = count / 1000;
        if (num == (count / 1000).toFixed(1)) {
          return num + "K";
        } else {
          return (count / 1000).toFixed(1) + "K+";
        }
      } else {
        return count;
      }
    }
  }
};
</script>
<style lang="less" scoped>
.detail-tool {
  display: flex;
  border-bottom: 1px solid #f0f0f0;
  align-items: center;
  justify-content: space-between;
  padding: 0 17px;
  .divider {
    width: 1px;
    background-color: #e3e3e3;
    height: 40px;
  }
  .item {
    width: 58px;
    height: 64px;
    border-radius: 30px;
    background-color: #fff;
    display: flex;
    flex-direction: column;
    align-items: center;
    // justify-content: center;
    padding-top: 12px;
    gap: 2px;
    font-weight: 400;
    font-size: 12px;
    color: #999999;
    line-height: 14px;
    cursor: pointer;
    .icon {
      font-size: 0;
      width: 28px;
      height: 28px;
    }
    .txt {
      color: #424242;
      font-size: 11px;
    }
  }
}
</style>
